<!-- @update:model-value="onUserSelected" -->
<template>
  <div style="display: flex; align-items: center; height: 100%; width: 100%;">
    <!-- Back button -->
    <v-btn
      size="small"
      fab
      color="grey lighten-3"
      style="margin-left: 0px; margin-right: 10px; flex-shrink: 0;"
      @click="cancelAddToCall()"
    >
      <v-icon color="primary">mdi-arrow-left</v-icon>
    </v-btn>

    <!-- Selection area -->
    <div style="flex: 1; min-width: 0; width: 100%;">
      <!-- Search field for combined list -->
      <v-autocomplete
        v-model="selectedEntry"
        :items="flatList"
        :item-title="getItemTitle"
        :item-value="getItemValue"
        label="Search users and contacts"
        variant="outlined"
        density="compact"
        hide-details
        style="background-color: #eeeeee; width: 100%;"
        @update:search="onAutocompleteSearch"
        :menu-props="{ maxHeight: 300, width: 'auto' }"
        clearable
        prepend-inner-icon="mdi-magnify"
        :filter="() => true"
      >
        <template v-slot:item="{ item, index, props }">
          <v-list-item v-bind="omitListItemProps(props)" >
            <template v-slot:prepend>
              <UserPopup v-if="item.raw.type === 'user'" :user_id="item.raw.item.user_id" :tooltip="true" size="small" />
              <ContactPopup v-else :contact_id="item.raw.item.contact_id" :tooltip="true" size="small" />                                                                   
            </template>
            <v-list-item-title>
              <div style="display: flex; flex-direction: row; align-items: center; width: 100%; justify-content: space-between;">
                <!-- Name/details on the left -->                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
                <div>
                  {{ item.raw.type === 'user'
                    ? (item.raw.item.username || item.raw.item.first_name + ' ' + (item.raw.item.last_name || ''))
                    : item.raw.item.first_name + ' ' + item.raw.item.last_name
                  }}
                  <!-- {{ hasMoreContacts }} {{index}} {{flatList.length - 1}} -->
                </div>
                <div v-if="item.raw.type === 'contact'">
                  <span style="display: flex; align-items: center; gap: 4px;">
                    <v-tooltip v-if="item.raw.item.ph1" location="bottom" :text="formatPhoneNumber(item.raw.item.ph1)">
                      <template v-slot:activator="{ props }">
                        <v-btn v-bind="props" variant="text" style="width: 22px; height: 22px;" icon @click.stop="addUser(item.raw.item, 'customer', 'contact', item.raw.item.ph1)">
                          <v-icon size="small" color="green">mdi-cellphone</v-icon>
                        </v-btn>
                      </template>
                    </v-tooltip>
                    <v-tooltip v-if="item.raw.item.ph2" location="bottom" :text="formatPhoneNumber(item.raw.item.ph2)">
                      <template v-slot:activator="{ props }">
                        <v-btn v-bind="props" variant="text" style="width: 22px; height: 22px;" icon @click.stop="addUser(item.raw.item, 'customer', 'contact', item.raw.item.ph2)">
                          <v-icon size="small" color="green">mdi-home</v-icon>
                        </v-btn>
                      </template>
                    </v-tooltip>
                    <v-tooltip v-if="item.raw.item.ph3" location="bottom" :text="formatPhoneNumber(item.raw.item.ph3)">
                      <template v-slot:activator="{ props }">
                        <v-btn v-bind="props" variant="text" style="width: 22px; height: 22px;" icon @click.stop="addUser(item.raw.item, 'customer', 'contact', item.raw.item.ph3)">
                          <v-icon size="small" color="green">mdi-briefcase</v-icon>
                        </v-btn>
                      </template>
                    </v-tooltip>
                  </span>
                </div>
                <div v-else style="display: flex; align-items: center; gap: 4px;">
                  <!-- Add as Agent -->
                  <v-tooltip location="bottom" text="Add as Agent">
                    <template v-slot:activator="{ props }">
                      <v-btn
                        v-bind="props"
                        variant="text"
                        style="width: 22px; height: 22px;"
                        icon
                        @click.stop="addUser(item.raw.item, 'Agent', 'user')"
                      >
                        <v-icon size="small" color="primary">mdi-account-plus</v-icon>
                      </v-btn>
                    </template>
                  </v-tooltip>

                  <!-- Add as Supervisor -->
                  <v-tooltip location="bottom" text="Add as Supervisor">
                    <template v-slot:activator="{ props }">
                      <v-btn
                        v-bind="props"
                        variant="text"
                        style="width: 22px; height: 22px;"
                        icon
                        @click.stop="addUser(item.raw.item, 'Supervisor', 'user')"
                      >
                        <v-icon size="small" color="primary">mdi-account-tie</v-icon>
                      </v-btn>
                    </template>
                  </v-tooltip>
                </div>
              </div>
            </v-list-item-title>
            <v-list-item-subtitle style="color: #757575">
              <span :style="item.raw.type === 'user' ? 'color: #757575' : ''">
                {{ item.raw.type }}
              </span>
            </v-list-item-subtitle>
          </v-list-item>
          <!-- Load More Option -->
          <v-list-item v-if="hasMoreContacts && index === flatList.length - 1" @click="loadMoreContacts" style="cursor: pointer; justify-content: center;">
            <v-list-item-title class="text-center" style="width: 100%; color: #1976d2; font-weight: 500;">Load More...</v-list-item-title>
          </v-list-item>
        </template>
      </v-autocomplete>

    </div>
  </div>
</template>

<script>
import colorMixin from "@/mixins/colorMixin";
import UserPopup from "@/components/Avatar/UserPopup";
import ContactPopup from "@/components/Avatar/ContactPopup";
import { mapGetters } from "vuex";
import { phoneFormat } from "@/util/util";
import { ClickOutside } from "vuetify/directives";
// Import RecycleScroller for virtual scrolling
import { RecycleScroller } from "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";

export default {
  name: "AddToCallDisplay",
  components: { UserPopup, ContactPopup, RecycleScroller },
  directives: { ClickOutside },
  mixins: [colorMixin],
  data() {
    return {
      selectedUser: null,
      searchTerm: "",
      currentPage: 1,
      pageSize: 20, // Number of contacts to load at once
      isLoadingMore: false,
      selectedEntry: null,
      loadedContactsCount: 20, // Track how many contacts are loaded
    };
  },
  computed: {
    ...mapGetters(["userId", "firstName", "lastName"]),
    ...mapGetters("plivo", ["getCurrConferenceName"]),
    ...mapGetters(["clientId"]),
    ...mapGetters("people", ["users", "contactsHash"]),

    // Get all contacts from the store
    contacts: function() {
      return Object.values(this.contactsHash || {});
    },
    
    // Filter users based on search term
    filteredUsers: function() {
      const temp = this.users.filter((user) => {
        // If the user is the current user in the browser, we will not
        // add them to the list of 'filteredUsers' because we don't want
        // the browser user to add themselves to the call (they are already in it)
        if (user.user_id === this.userId) return false;
        return true;
      });
      
      // Apply search filter if there's a search term
      if (this.searchTerm) {
        const query = this.searchTerm.toLowerCase();
        return temp.filter(user => {
          const username = (user.username || "").toLowerCase();
          const firstName = (user.first_name || "").toLowerCase();
          const lastName = (user.last_name || "").toLowerCase();
          const fullName = `${firstName} ${lastName}`.toLowerCase();

          return username.includes(query) || 
                firstName.includes(query) || 
                lastName.includes(query) ||
                fullName.includes(query);
        });
      }
      return temp;
    },
    
    // Filter contacts based on search term with optimization for large lists
    filteredContacts: function() {
      if (!this.contacts || this.contacts.length === 0) {
        return [];
      }
      if (!this.searchTerm) {
        // Just return all contacts
        return this.contacts;
      }
      
      // When searching, we need to search through all contacts
      // but we can optimize by using more efficient string operations
      const query = this.searchTerm.toLowerCase();
      
      // Use a more efficient approach for large lists
      const results = [];
      const maxResults = 100; // Limit search results for very large lists
      
      for (let i = 0; i < this.contacts.length; i++) {
        const contact = this.contacts[i];
        const firstName = (contact.first_name || "").toLowerCase();
        const lastName = (contact.last_name || "").toLowerCase();
        
        // Check most common fields first for early termination
        if (firstName.includes(query) || lastName.includes(query)) {
          results.push(contact);
          if (results.length >= maxResults) break;
          continue;
        }
        
        // Only check these if the above didn't match
        const fullName = `${firstName} ${lastName}`.toLowerCase();
        if (fullName.includes(query)) {
          results.push(contact);
          if (results.length >= maxResults) break;
          continue;
        }
        
        // Phone numbers are checked last as they're less commonly searched
        const phone1 = (contact.ph1 || "").toLowerCase();
        const phone2 = (contact.ph2 || "").toLowerCase();
        const phone3 = (contact.ph3 || "").toLowerCase();
        
        if (phone1.includes(query) || phone2.includes(query) || phone3.includes(query)) {
          results.push(contact);
          if (results.length >= maxResults) break;
        }
      }
      
      return results;
    },
    
    // Paginated contacts based on current page
    paginatedContacts: function() {
      // Instead of slicing by page, slice by loadedContactsCount
      return this.filteredContacts.slice(0, this.loadedContactsCount);
    },
    
    // Total number of pages needed for contacts
    totalPages: function() {
      return Math.ceil(this.filteredContacts.length / this.pageSize);
    },
    
    // Whether there are more contacts to load
    hasMoreContacts: function() {
      return this.loadedContactsCount < this.filteredContacts.length;
    },

    flatList() {
      // Users first, then paginated contacts
      return [
        ...this.filteredUsers.map(u => ({ type: 'user', item: u })),
        ...this.paginatedContacts.map(c => ({ type: 'contact', item: c }))
      ];
    },
  },
  methods: {
    getItemTitle(item) {
      if (!item) return '';
      if (item.type === 'user') {
        const user = item.item;
        return user.username || `${user.first_name || ''} ${user.last_name || ''}`.trim();
      } else if (item.type === 'contact') {
        const contact = item.item;
        return `${contact.first_name || ''} ${contact.last_name || ''}`.trim();
      }
      return '';
    },
    omitListItemProps(originalProps) {
      const { title, subtitle, value, ...rest } = originalProps
      return rest
    },

    // Format phone number for display
    formatPhoneNumber(phoneNumber) {
      return phoneFormat(phoneNumber) || phoneNumber;
    },
    
    // Update search term with debounce
    // updateSearchTerm(value) {
    //   this.searchTerm = value;
    //   this.resetPagination();
    // },
    
    // Method to add user as a supervisor
    async addUser(item, role, type, number) {
      try{
        console.log('Adding user as supervisor:', item, this.getCurrConferenceName, );
        let payload = {
          "from": this.userId,
          "to": type=='contact' ? number : item.user_id,
          "role": role,
          "type": type,
          "clientId": this.clientId,
          "conferenceName": this.getCurrConferenceName
        };

        this.$emit("dismount", payload);
      }catch(err){
        console.error("error in adding user",err);
      }
    },

    cancelAddToCall() {
      // No need for payload, as 'CallBar' doesn't have to make a request to the backend to add a user to the call.
      this.$emit("dismount", null);
    },
    
    // Load more contacts when the Load More button is clicked
    loadMoreContacts() {
      this.isLoadingMore = true;
      setTimeout(() => {
        // Instead of incrementing page, increase loadedContactsCount
        this.loadedContactsCount = Math.min(
          this.loadedContactsCount + this.pageSize,
          this.filteredContacts.length
        );
        this.isLoadingMore = false;
      }, 300); // Small delay for better UX
    },
    
    // Reset pagination when search term changes
    resetPagination() {
      this.currentPage = 1;
      this.loadedContactsCount = this.pageSize;
    },

    onAutocompleteSearch(val) {
      this.searchTerm = val;
      this.resetPagination();
    },

    getItemValue(item) {
      if (!item) return '';
      return item.type + '-' + (item.type === 'user' ? item.item.user_id : item.item.contact_id);
    },
  },
  created() {
    // Ensure contacts are loaded
    if (!this.contacts || this.contacts.length === 0) {
      this.$store.dispatch('people/getContacts').then(() => {
        console.log(`Loaded ${this.contacts.length} contacts`);
      });
    }
  },
  
  // mounted() {
  //   // Create debounced search method in mounted hook to ensure proper this binding
  //   this.debouncedSearch = debounce(this.updateSearchTerm, 300);
  // },

  // watch: {
  //   selectedEntry(newVal) {
  //     if (!newVal) return;
  //     if (newVal.type === 'user') {
  //       this.addUserAsAgent(newVal.item);
  //     } else if (newVal.type === 'contact') {
  //       this.addContactAsAgent(newVal.item);
  //     }
  //     this.selectedEntry = null;
  //   }
  // }
};
</script>

<style scoped>
:deep(.v-autocomplete__content) {
  z-index: 9999 !important;
}

:deep(.v-list) {
  z-index: 9999 !important;
}

/* Styles for hover options */
.user-list-item,
.contact-list-item {
  position: relative;
}

.hover-options {
  position: absolute;
  right: 10px;
  display: none;
  gap: 8px;
}

.user-list-item:hover .hover-options,
.contact-list-item:hover .hover-options {
  display: flex;
}

.hover-btn {
  position: relative;
  min-width: auto;
  padding: 0 8px;
}

.hover-text {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  display: none;
  z-index: 10;
  margin-top: 5px;
}

.agent-btn:hover .hover-text,
.supervisor-btn:hover .hover-text {
  display: block;
}

/* List styling */
:deep(.v-list-item) {
  padding: 8px 16px;
}

:deep(.v-list-item__prepend) {
  margin-right: 12px;
}

/* Section headers */
:deep(.v-list-subheader) {
  background-color: #f5f5f5;
  font-weight: 500;
  font-size: 0.9rem;
  padding: 0 16px;
  height: 36px;
}

/* Styles for load more container */
.load-more-container {
  padding: 8px 16px;
  background-color: #fafafa;
}

/* Ensure the list has a max height and scrolls properly */
.v-list {
  max-height: 300px;
  overflow-y: hidden; /* Changed from auto since RecycleScroller handles scrolling */
}

.contacts-scroller {
  height: 300px;
  width: 100%;
}

/* Ensure list items in the scroller have proper styling */
.contacts-scroller .contact-list-item {
  width: 100%;
}

.highlighted {
  background-color: #e0e0e0 !important;
}
</style>
